import {
  ChevronLeft,
  ChevronRight
} from '@mui/icons-material';
import {
  Box,
  Button,
  IconButton,
  useTheme
} from '@mui/material';
import { CustomIcon } from 'modules/components/layer00';
import { TaskPaneCard } from 'modules/components/layer05';
import { SaveTaskModal } from 'modules/components/layer17';
import React, { useState } from 'react';



export type PlanTaskPaneProps = {
  expanded: boolean;
  showDetail: React.Dispatch<React.SetStateAction<boolean>>;
  width: string;
  tasks: Omit<TaskPaneCard.TaskPaneCardProps, 'showTaskModal'>[];
};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FC = (props: PlanTaskPaneProps) => {
  const theme = useTheme();
  const [
    isTaskVisible,
    setIsTaskVisible
  ] = useState(false);

  const [
    taskId,
    setTaskId
  ] = useState<null | string>(null);

  const handleClick = (id: string) => {
    setIsTaskVisible(() => true);
    setTaskId(() => id);
  };


  if (props.expanded) {
    return (
      <Box
        position='fixed'
        bgcolor={theme.palette.background.default}
        width={props.width}
        height='20%'
        bottom={0}
        left={0}
      >
        <Box
          position='relative'
          marginX='1.5rem'
          height='100%'
          marginY='0rem'
        >
          {/* CAROLSEL */}
          <Box
            component='div'
            sx={{
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'row',
              height: '90%',
              margin: 0,
              padding: 0,
              overflow: 'hidden',
              columnGap: '1rem',
              overflowX: 'auto',
              scrollSnapType: 'x mandatory',
              scrollBehavior: 'smooth',
              scrollbarWidth: 'none'
            }}
          >
            <ChevronLeft />
            {props.tasks.map((node, i) => (
              <>
                <TaskPaneCard.FC
                  key={`${node.id}-${i}`}
                  id={node.id}
                  title={node.title}
                  showTaskModal={handleClick}
                  area={node.area}
                  category={node.category}
                  dueIn={node.dueIn}
                  flex='1 1 0'
                />
                {isTaskVisible && taskId && (
                  <SaveTaskModal.FC
                    id={taskId}
                    isVisible={isTaskVisible}
                    handleClose={() => {
                      setIsTaskVisible(() => false);
                      setTaskId(() => null);
                    }}
                  />
                )}
              </>
            ))}


            <IconButton
              onClick={() => props.showDetail(() => false)}
              color='primary'
              sx={{
                position: 'absolute',
                right: -20,
                top: 0
              }}
            >
              <CustomIcon.large.FC
                icon='CLOSE'
                stroke={theme.palette.primary.main}
              />
            </IconButton>


          </Box>
        </Box>
      </Box>
    );
  }
  return (
    <Box
      position='fixed'
      left={40}
      bottom={40}
      width='10rem'
      height='40px'
      zIndex={1000}
      onClick={() => {
        props.showDetail(() => true);
      }}
    >
      <Button
        variant='contained'
        color='primary'
      >
        Tasks
      </Button>
    </Box>
  );
};
